export const downloadBlob = (blob: Blob, name: string): Promise<boolean> => {
  if (!name) throw new Error('Name is required');
  if (!blob) throw new Error('File is required');
  return new Promise((resolve, reject) => {
    try {
      // Convert your blob into a Blob URL (a special url that points to an object in the browser's memory)
      const blobUrl = URL.createObjectURL(blob);
      // Create a link element
      const link = document.createElement('a');
      // Set link's href to point to the Blob URL
      link.href = blobUrl;
      link.download = name;
      // Append link to the body
      document.body.appendChild(link);
      // Dispatch click event on the link
      // This is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      );
      // Remove link from body
      document.body.removeChild(link);
      resolve(true);
    } catch (error) {
      reject('Error: ' + error);
    }
  });
};
export const getBinaryFromFile = (file: File): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.addEventListener('load', () =>
      resolve(new Blob([reader.result as ArrayBuffer]))
    );
    reader.addEventListener('error', (err) => reject(err));

    reader.readAsArrayBuffer(file);
  });
};
